angular.module('impactx.deliverynote').controller('DeliveryNoteItemCtrl', ['$scope', DeliveryNoteItemController]);

function DeliveryNoteItemController($scope) {
    var self = this;

    self.canDelete = function(item){
        if(self.readOnly || self.isDeletedList) {
            return false;
        }
        if(item.isAdditional || item.isReplacement){
            return item.canDelete;
        }
        return $scope.$parent.data.dnh.deliveryNoteItems.filter(function(entry){
            return !entry.isAdditional;
        }).length > 1 && item.canDelete;
    };

    self.canRecreate = function() {
        return self.isDeletedList;
    };

    self.toggleSelection = function (event, item) {
        if (!self.isDeletedList) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            var index = $scope.selectedItems.indexOf(item);
            if (index >= 0) {
                item.selected = false;
                $scope.selectedItems.splice(index, 1);
            }
            else {
                $scope.selectedItems.push(item);
                item.selected = true;
            }
        }
    };
}

